"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogger = void 0;
const consoleRef = console;
class ConsoleLogger {
    debug(...whatever) {
        consoleRef.log(...whatever);
    }
    log(...whatever) {
        consoleRef.log(...whatever);
    }
    error(...whatever) {
        consoleRef.error(...whatever);
    }
    warn(...whatever) {
        consoleRef.warn(...whatever);
    }
    info(...whatever) {
        consoleRef.info(...whatever);
    }
}
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=ConsoleLogger.js.map